const baseURL: string = "https://jjrentalapi.azurewebsites.net/api/";
const ticketBaseURL: string = "https://jvcrm-api.azurewebsites.net/api/";
const appName: string = "RDRENTAL";
const appId: string = "7";

export default baseURL;
export { ticketBaseURL, appName, appId };
